import type { GetReferralOfferResponse, ReferralOfferResult } from 'models/reqres';

export function mapReferralOfferResponse(data: GetReferralOfferResponse): ReferralOfferResult {
    const valid = data.valid ?? undefined;
    if (valid !== true || !data.referee) {
        return { valid, type: data.type ?? undefined, isVariable: false };
    }

    const referee = data.referee;
    const rewardDetails = referee.reward_details;
    const isPerpsFeeReduction = referee.product === 'perps' && referee.reward_type === 'fee_reduction';
    const feeReductionOffer = rewardDetails?.fee_reduction_offer;

    return {
        valid: true,
        type: data.type ?? undefined,
        referrerFirstName: data.referrer?.display_name ?? undefined,
        refereeCreditCents: rewardDetails?.flat_reward?.payout_amount_cents,
        tradeThresholdCents: referee.trade_threshold_cents ?? undefined,
        maxReferralRewardCents: rewardDetails?.variable_reward?.max_reward_cents,
        feeReductionOffer:
            isPerpsFeeReduction && feeReductionOffer != null
                ? {
                      reduction_bps: feeReductionOffer.reduction_bps,
                      duration_days: feeReductionOffer.duration_days,
                  }
                : undefined,
        refereeFlatBonusCents: isPerpsFeeReduction
            ? (rewardDetails?.flat_offer?.reward_amount_cents ?? null)
            : undefined,
        isVariable: referee.reward_type === 'variable',
    };
}
